import { useEffect, useState } from 'react';

export const REPORT_TIME_ZONE = 'America/Toronto';
export const reportDate = (now = new Date()) => new Intl.DateTimeFormat('en-CA', {
  timeZone: REPORT_TIME_ZONE, year: 'numeric', month: '2-digit', day: '2-digit',
}).format(now);

// Refresh visible reports and catch up immediately after sleep, reconnect or tab return.
export const useReportClock = () => {
  const [now, setNow] = useState(() => new Date());
  useEffect(() => {
    const update = () => {
      if (document.visibilityState !== 'hidden') setNow(new Date());
    };
    const timer = window.setInterval(update, 60000);
    window.addEventListener('focus', update);
    window.addEventListener('online', update);
    document.addEventListener('visibilitychange', update);
    return () => {
      window.clearInterval(timer);
      window.removeEventListener('focus', update);
      window.removeEventListener('online', update);
      document.removeEventListener('visibilitychange', update);
    };
  }, []);
  return now;
};
